import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Option {
  LeftElement: JSX.Element
  leftText: string
  rightText: string
  value: string
}

interface useFormLabelsProps {
  transferWalletOptions: Option[]
  isCustomerWalletTransferType: boolean
}

export const useFormLabels = ({
  transferWalletOptions,
  isCustomerWalletTransferType,
}: useFormLabelsProps) => {
  const { t } = useTranslation()

  const selectBeneficiaryDropdownPlaceholder = useMemo(() => {
    if (!!transferWalletOptions && !transferWalletOptions?.length) {
      return t('noWallets')
    } else {
      return t('select')
    }
  }, [transferWalletOptions])

  const destinationWalletLabel = useMemo(() => {
    if (isCustomerWalletTransferType) {
      return t('customers.selectCustomerWallet')
    }

    return t('selectWallet')
  }, [isCustomerWalletTransferType])

  return {
    selectBeneficiaryDropdownPlaceholder,
    destinationWalletLabel,
  }
}
